import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { DisplayName } from '../DisplayName';
import { NetState } from '../NetState';
import { FooterPlayerCount } from '../PlayerCount';
import './index.scss';
export const Footer = () => {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className={'lobby-footer'}
            padding={'0 0.25rem'}
        >
            <Box>
                <FooterPlayerCount hostId={-1} />
            </Box>
            <Box>
                {/* <EncryptNetState
                    alignContent={'center'}
                    className="my-font-10"
                /> */}
                <Stack direction="row" spacing={0.5}>
                    <DisplayName />
                    <NetState
                        alignContent={'center'}
                        includeParentheses={true}
                    />
                </Stack>
            </Box>
        </Stack>
    );
};
